export default __webpack_public_path__ + "static/media/Nesha_Laser_0012_Laser_5.f6fe058b.png";